import { GiftIcon, HeartIcon, OngoingIcon, ProfileIcon, WalletIcon } from 'assets/Icons';
import { MdCategory, MdOutlinePendingActions } from 'react-icons/md';

import { NavLinkProps as NavigationLink } from 'components/atoms/NavLinks/NavLinks';
import { CATEGORIES, FAVOURITE, ORDERS, PENDING_PAYMENTS, PROFILE, REFER, WALLET } from '../routes';

export const NAVIGATION_LINKS: readonly NavigationLink[] = [
  {
    label: 'Profile',
    to: PROFILE,
    Icon: ProfileIcon
  },
  {
    label: 'My Orders',
    to: ORDERS,
    Icon: OngoingIcon
  },
  {
    label: 'My Wallet',
    to: WALLET,
    Icon: WalletIcon
  },
  {
    label: 'Favourites',
    to: FAVOURITE,
    Icon: HeartIcon
  },
  {
    label: 'Refer a Friend',
    to: REFER,
    Icon: GiftIcon
  }
  // {
  //   label: 'Delete account',
  //   to: DELETE_ACCOUNT,
  //   Icon: AiOutlineUserDelete
  // }
] as const;

const excludeFromBusiness = ['Profile', 'My Orders', 'Refer a Friend'];

export const BUSINESS_NAVS: NavigationLink[] = [
  ...[
    {
      label: 'Profile',
      to: PROFILE,
      Icon: ProfileIcon
    },
    {
      label: 'My Orders',
      to: ORDERS,
      Icon: OngoingIcon
    },
    {
      label: 'Categories',
      to: CATEGORIES,
      Icon: MdCategory
    },
    {
      label: 'Pending Payments',
      to: PENDING_PAYMENTS,
      Icon: MdOutlinePendingActions
    }
  ],
  ...NAVIGATION_LINKS.filter(item => !excludeFromBusiness.includes(item.label))
];
